import { render, staticRenderFns } from "./Getquote.vue?vue&type=template&id=ded8d5cc&"
import script from "./Getquote.vue?vue&type=script&lang=js&"
export * from "./Getquote.vue?vue&type=script&lang=js&"
import style0 from "./Getquote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports